import React from 'react';
import './style.css';

const AboutImporterr = () => {
  return (
    <section className="importerr-about-section">
      <div className="importerr-about-card">
        
        <p className="importerr-about-description">
          <strong>Importerr.com</strong> helps Entrepreneurs, Corporates, MSME, Ecommerce Sellers, and D2C Brands source unique products directly from tested global Chinese suppliers.
        </p>
        
        <p className="importerr-about-description">
          We operate without multiple middlemen, ensuring no hidden costs and no high MOQs. All products are fully compliant and GST-ready, meaning you can import with absolutely no documentation required.
        </p>

      </div>
    </section>
  );
};

export default AboutImporterr;